module.exports = __webpack_public_path__ + "img/58bfe191cb0f27fe7bb3fd8f1a54c789.png";